<template>
    <div class="tabs-wap">
        <div class="tabs-list header" id="tabs">
            <label
                class="tabs-item"
                v-for="item in filteredTabs"
                :key="item.key"
                :class="item.key === tabKey ? 'active' : ''"
                @click="tabsClick(item)"
            >
                {{ item.label }}
            </label>
        </div>
        <!-- style="min-height: 90vh;" -->
        <div style="padding-bottom: 80px" id="tabConEle">
            <zixun-list v-if="tabKey === 'zixun'"></zixun-list>
            <gonggao-list v-if="tabKey === 'gonggao'"></gonggao-list>
            <yanbao-tab v-if="tabKey === 'yanbao'"></yanbao-tab>
            <!-- HK, USA, CN -->
            <jiankuang-tab
                v-if="tabKey === 'jiankuang' && region === 'CN'"
            ></jiankuang-tab>
            <gmg-jiankuang
                v-if="tabKey === 'jiankuang' && region !== 'CN'"
            ></gmg-jiankuang>
            <caibao-tab v-if="tabKey === 'caiwu'"></caibao-tab>
            <guba-tab v-if="tabKey === 'guba'"></guba-tab>
            <bankuai-tab v-if="tabKey === 'bankuai'" />
            <stockfocus v-if="tabKey === 'focus'" />
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import zixunList from './zixunlist'
import gonggaoList from './gonggaolist'
import yanbaoTab from './yanbaotab'
import jiankuangTab from './jiankuangtab'
import gmgJiankuang from './gmgBrief'
import caibaoTab from './caibaotab'
import gubaTab from './gubatab'
import bankuaiTab from './bankuaitab'
import stockfocus from './stockfocus'
import { request } from '@/api/request'


export default {
    computed: {
        ...mapState({
            tabs: state => state.common.tabs,
            tabKey: state => state.common.tabKey,
            isIndex: state => state.isIndex,
            region: state => state.region,
            symbol: state => state.symbol,
            market: state => state.market,
        }),
        filteredTabs() {
            if (this.market === 'bj') {
                return this.tabs.filter(tab => tab.key !== 'bankuai')
            }
            return this.tabs
        }
    },
    components: { zixunList, gonggaoList, yanbaoTab, jiankuangTab, caibaoTab, gmgJiankuang, gubaTab, bankuaiTab, stockfocus },

    mounted() {
        this.getStockFocusData()
    },

    methods: {
        ...mapMutations({
            setTabKey: 'common/setTabKey',
            setTabIndex: 'common/setTabIndex',
            setTabs: 'common/setTabs'
        }),
        async getStockFocusData() {
            const result = await request.get({
                url: request.apis.news.getSpecifiedColumnList,
                params: {
                    market: this.market,
                    symbol: this.symbol,
                    columnCodes: '9fztgw_jfsd',
                    appCode: '9fztgw',
                    showPermission: 0,
                },
                headers: {
                    whiteList: 'rjhy-news'
                }
            })
            if (result) {
                const { newsList, columnBeans } = result
                const res = this.tabs.filter(v => v.key == 'focus')[0]
                res.label = columnBeans['9fztgw_jfsd']
                res.list = newsList
                this.setTabs(this.tabs)
            }

        },
        getElementTop(element) {
            var actualTop = element.offsetTop
            var current = element.offsetParent

            while (current !== null) {
                actualTop += current.offsetTop
                current = current.offsetParent
            }
            return actualTop
        },
        tabsClick(item) {
            let top = this.getElementTop(document.querySelector('#tabConEle'))
            //console.log('---top', top)
            window.scrollTo(0, top - 95)
            const index = this.tabs.findIndex(el => el.key === item.key)
            this.setTabKey(item.key)
            this.setTabIndex(index)
        }
    }
}
</script>

<style lang="stylus" scoped>
.tabs-wap
    margin-top 0.06rem
    height auto
    color #666666
    background #fff

    // 0px 7px
    #tabs
        width 100%
        overflow auto
        box-sizing border-box
        -webkit-overflow-scrolling touch

        &::-webkit-scrollbar
            display none

    .header
        position -webkit-sticky
        position sticky
        top 1.11rem
        background #fff
        z-index 101

    .tabs-list
        border-bottom 1px solid #edeff3
        display flex
        padding 0 7px

        // height 34px
        .tabs-item
            font-size 16px
            margin 5px 7px 0 0
            padding 7px 5px
            // margin-bottom 7px
            font-weight 400
            // height 21px
            line-height 21px
            white-space nowrap
            flex none

            &.active
                color #f43737
                position relative

                &:after
                    content ''
                    height 2px
                    position absolute
                    right 7px
                    left 7px
                    bottom 0
                    background #f43737

            &:last-child
                margin-right 0
</style>